import { IAppState } from '../../../AppModulesWrapper';

export const selectUser = (state: IAppState) => {
  return state.servicePickerWidget.user;
};
